export default {
  mytopic_my_reply: 'My Replies',
  mytopic_my_collect: 'My favorites',
  mytopic_post_manage: 'Posts removed',
  mytopic_comment_manage: 'Comments and replies removed',
  mytopic_cancel_collect: 'Cancel adding to favorite',
  mytopic_comfirm_collect: 'Confirm that your changes will not be saved?',
  mytopic_restore_success: 'Restored to shelves successfully',
  mytopic_restore_failed: 'Failed to restore to shelves',
  mytopic_resume: 'Restore to shelves',
  mytopic_confirm_resume: 'Restore to shelves?' ,
  mytopic_make_comment: 'Comment: ',
  mytopic_make_collect: 'Add to favorites: ',
  mytopic_make_like: 'Like:',
  mytopic_del_failed: 'Failed to delete',
  mytopic_confirm_del_now: 'Delete?' ,
  mytopic_del_success: 'Delete successfully',
}
